import React from 'react';
import { Box } from '@mui/material';
import {
  getPaymentStatusDisplay,
  getInspectionStatusDisplay,
} from '../constants/inspectionStatusConfigs';

const chipStyle = {
  color: 'white',
  padding: '4px 12px',
  borderRadius: '16px',
  fontSize: '14px',
  fontWeight: 500,
  display: 'inline-block',
  whiteSpace: 'nowrap',
};

export const StatusChip = ({ label, backgroundColor }) => (
  <span
    style={{
      ...chipStyle,
      backgroundColor,
    }}
  >
    {label}
  </span>
);

export const PaymentStatusChip = ({ status }) => {
  const { label, backgroundColor } = getPaymentStatusDisplay(status);
  return <StatusChip label={label} backgroundColor={backgroundColor} />;
};

export const InspectionStatusChip = ({ inspectionStatus }) => {
  const { label, backgroundColor } = getInspectionStatusDisplay(inspectionStatus);
  return <StatusChip label={label} backgroundColor={backgroundColor} />;
};

export const InspectionValueChip = ({ value }) => (
  <Box
    sx={{
      display: 'inline-block',
      background:
        'linear-gradient(90deg, rgba(15, 133, 246, 0.12) 0%, rgba(2, 80, 217, 0.12) 100%)',
      color: '#012F47',
      borderRadius: '16px',
      padding: '4px 12px',
      fontSize: '0.875rem',
      fontWeight: 500,
    }}
  >
    {new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value)}
  </Box>
);
